"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montefalcione": {
    "6bab40a7": [{
      "hkey": "9787fc8f",
      "slug": "montefalcione",
      "name": "Montefalcione",
      "primary": true,
      "skipSearch": false
    }],
    "carrani": [{
      "hkey": "9787fc8f",
      "slug": "montefalcione",
      "name": "Montefalcione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "90a779dd": [{
      "hkey": "9787fc8f",
      "slug": "montefalcione",
      "name": "Montefalcione",
      "primary": true,
      "skipSearch": false
    }],
    "cataldi": [{
      "hkey": "9787fc8f",
      "slug": "montefalcione",
      "name": "Montefalcione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a8fb48e7": [{
      "hkey": "9787fc8f",
      "slug": "montefalcione",
      "name": "Montefalcione",
      "primary": true,
      "skipSearch": false
    }],
    "croce": [{
      "hkey": "9787fc8f",
      "slug": "montefalcione",
      "name": "Montefalcione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a0a4efda": [{
      "hkey": "9787fc8f",
      "slug": "montefalcione",
      "name": "Montefalcione",
      "primary": true,
      "skipSearch": false
    }],
    "verzare-lolli": [{
      "hkey": "9787fc8f",
      "slug": "montefalcione",
      "name": "Montefalcione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;